import { FeatureCalendar } from '@mdlbeasts/nofomo.ui.web';

import { DateFormat, i18nFormat } from 'utils/date.utils';

import { SiteLocale } from 'constants/i18n.constants';

// Turns a "yyyy-MM-dd" key into a date. Null if the key is not valid.
export const parseDayKey = (key: string): Date | null => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(key);

  if (!match) return null;

  const date = new Date(
    Number(match[1]),
    Number(match[2]) - 1,
    Number(match[3]),
  );

  return Number.isNaN(date.getTime()) ? null : date;
};

// The months to render: `count` of them from `anchor`'s month onward.
export const buildMonths = (
  anchor: Date,
  count: number,
  locale: SiteLocale,
): Array<FeatureCalendar.CalendarMonth> =>
  Array.from({ length: count }, (_, index) => {
    const date = new Date(anchor.getFullYear(), anchor.getMonth() + index, 1);

    return {
      year: date.getFullYear(),
      month: date.getMonth(),
      label: i18nFormat(date, DateFormat.MonthYearLong[locale], locale),
    };
  });

// Whole months from `anchor` to `date`, never negative.
export const monthsUntil = (anchor: Date, date: Date): number =>
  Math.max(
    0,
    (date.getFullYear() - anchor.getFullYear()) * 12 +
      date.getMonth() -
      anchor.getMonth(),
  );
